import { isFeature } from 'Cloud/Application/FeaturesEs6';

/** CLOUDWEB: 20095 - Включает модалку 3-в-ряд для мобильных устройств */
export const mobileTariffsModalEnabled = isFeature('mobile-tariffs-modal-enabled');
